import { useCanAccessFeature } from '../../hooks/usePermissions';
import { filterQuickCreateTiles } from '../../lib/quickCreate';

export function useQuickCreateTiles() {
  const allowed = {
    dossier: useCanAccessFeature('dossiers_create'),
    task: useCanAccessFeature('tasks_create'),
    audience: useCanAccessFeature('hearings_create'),
    appointment: useCanAccessFeature('appointments_manage'),
    contact: useCanAccessFeature('contacts_edit'),
    timeEntry: useCanAccessFeature('time_entries_create'),
  };
  return filterQuickCreateTiles(allowed);
}
